import { useState } from 'react';
import { ExternalLink, RefreshCw, TerminalSquare } from 'lucide-react';

export default function CodeUpdate() {
  const [frameKey, setFrameKey] = useState(0);

  return (
    <div className="flex h-full flex-col bg-[#f4ead7]">
      <div className="studio-toolbar flex items-center gap-3 border-b px-4 py-2">
        <div className="flex items-center gap-2">
          <TerminalSquare className="h-4 w-4 text-[#7256c4]" />
          <span className="text-sm font-black tracking-[0.12em] text-[#2f2414]">Codex Mobile</span>
        </div>
        <span className="flex items-center gap-1 text-xs font-bold text-[#476b24]">
          <span className="h-1.5 w-1.5 rounded-full bg-[#76a441]" />
          Local Codex UI
        </span>
        <div className="flex-1" />
        <button
          onClick={() => setFrameKey(value => value + 1)}
          className="studio-button-quiet rounded-md p-1.5"
          title="Reload Codex Mobile"
        >
          <RefreshCw className="h-3.5 w-3.5" />
        </button>
        <a
          href="/codex-mobile/"
          target="_blank"
          className="studio-button-quiet rounded-md p-1.5"
          title="Open Codex Mobile in new tab"
        >
          <ExternalLink className="h-3.5 w-3.5" />
        </a>
      </div>

      <iframe
        key={frameKey}
        src="/codex-mobile/"
        className="h-full w-full flex-1 border-0 bg-white"
        title="Codex Mobile"
        allow="clipboard-read; clipboard-write; microphone"
      />
    </div>
  );
}
